export class Resolution {
  public width: Number;
  public height: Number;

  public constructor(resolution: Resolution) {
    Object.assign(this, resolution);
  }
}

export class Device {
  public name: string;
  public userAgent: string;

  public constructor(device: Device) {
    Object.assign(this, device);
  }
}

export class AllowedBrowser {
  public browser: string;
  public minimumVersion: string;
  public maximumVersion: string;
  public optionalValues = [];

  private separator = ':';

  public constructor(browser: string, value: string) {
    this.browser = browser;
    this.extractPropertiesFromReferenceData(value);
  }

  private extractPropertiesFromReferenceData(value: string): void {
    const values = value.split(this.separator);
    this.minimumVersion = values[0];
    this.maximumVersion = values[1];

    if (values.length > 1) {
      this.optionalValues = values.slice(2, values.length);
    }
  }
}

export interface Browser {
  name?: string;
  version?: string;
}

export interface OperatingSystem {
  name?: string;
  version?: string;
}

export type ContextPropertyType = Browser | OperatingSystem;

export class Context {
  public browser: Browser = {};
  public os: OperatingSystem = {};
  private separator = ':';

  public constructor(browser: string, os: string) {
    this.extractPropertiesFromReferenceData(browser, this.browser);
    this.extractPropertiesFromReferenceData(os, this.os);
  }

  private extractPropertiesFromReferenceData(source: string, property: any): void {
    const values = source.split(this.separator);
    property.name = values[0];

    if (values.length > 1) {
      property.version = values[1];
    }
  }
}
